import { render, staticRenderFns } from "./MoblieBorrow.vue?vue&type=template&id=5cedc750&scoped=true&"
import script from "./MoblieBorrow.vue?vue&type=script&lang=js&"
export * from "./MoblieBorrow.vue?vue&type=script&lang=js&"
import style0 from "./MoblieBorrow.vue?vue&type=style&index=0&id=5cedc750&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cedc750",
  null
  
)

export default component.exports